var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';
import { map, cloneDeep } from 'lodash';
import { default as AntInput } from 'antd/lib/input';

var MultiInput = function (_super) {
  __extends(MultiInput, _super);

  function MultiInput(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }

  MultiInput.prototype.handleChange = function (value, index) {
    var _a = this.props,
        array = _a.value,
        name = _a.name,
        onChange = _a.onChange;
    var cloneArray = cloneDeep(array);
    var newValue = parseInt(value, 10);
    cloneArray[index].value = isNaN(newValue) ? undefined : newValue;

    if (onChange) {
      onChange(cloneArray, name);
    }
  };

  MultiInput.prototype.render = function () {
    var _this = this;

    var array = this.props.value;
    return React.createElement("div", {
      className: 'multi-input-wrapper'
    }, map(array, function (item, index) {
      var id = item.id,
          name = item.name,
          value = item.value;
      return React.createElement(AntInput, {
        key: id,
        value: value,
        addonBefore: name,
        onChange: function onChange(e) {
          _this.handleChange(e.target.value, index);
        }
      });
    }));
  };

  return MultiInput;
}(Component);

export { MultiInput };